<template>
    <div>
        <user-workload-to-companies-modal></user-workload-to-companies-modal>
        <tasks-made-by-user-modal></tasks-made-by-user-modal>
        <workload-to-companies></workload-to-companies>
        <tasks-made-all-modal></tasks-made-all-modal>
        <h4 class="text-center">Atividades Geral</h4>
        <hr />
        <form class="row search">
            <div class="form-group col-md-12">
                <input v-on:keyup="search" class="form-control" id="search" v-model="search_user" ref="search" placeholder="Busca"/>
            </div>
        </form>
        <div v-if="loading" class="text-center loading-tasks"><i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i></div>

        <div v-else>
            <table class="table table-striped tasks-table">
                <thead>
                <tr>
                    <th>Usuário</th>
                    <th>Ações</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-if="user.role === 'supervisor'">
                        <td>Geral</td>
                        <td>
                            <button
                                class="btn btn-outline-secondary btn-sm"
                                title="Horas por empresa"
                                v-on:click="grandResume"
                            >
                                <i class="far fa-building"></i>
                            </button>
                            <button
                                class="btn btn-outline-primary btn-sm"
                                title="Atividades realizadas"
                                v-on:click="grandTasks"
                            >
                                <i class="fas fa-tasks"></i>
                            </button>
                        </td>
                    </tr>
                    <tr v-for="user in users" :key="user.id">
                        <td>
                            <span>{{ user.name }}</span>
                        </td>
                        <td>
                            <button
                                class="btn btn-outline-secondary btn-sm"
                                title="Horas por empresa"
                                v-on:click="resume(user)"
                            >
                                <i class="far fa-building"></i>
                            </button>
                            <button
                                class="btn btn-outline-primary btn-sm"
                                title="Atividades realizadas"
                                v-on:click="tasksUser(user)"
                            >
                                <i class="fas fa-tasks"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import Vue from 'vue'
    import { mapGetters} from 'vuex'
    import UserWorkloadToCompaniesModal from '../components/UserWorkloadToCompaniesModal'
    import TasksMadeByUserModal from '../components/TasksMadeByUserModal'
    import WorkloadToCompanies from '../components/WorkloadToCompaniesModal'
    import TasksMadeAllModal from '../components/TasksMadeAllModal'

    export default {
        name: 'TasksMadeUsers',
        components: {
            UserWorkloadToCompaniesModal,
            TasksMadeByUserModal,
            WorkloadToCompanies,
            TasksMadeAllModal
        },
        computed: {
            ...mapGetters({
                user: 'auth/user'
            })
        },
        provide () {
            return {
                eventHub: this.eventHub
            }
        },
        data () {
            return {
                eventHub: new Vue (),
                users: {},
                loading: true,
                search_user: '',
                searchTimeout: null
            }
        },
        mounted (){
            this.index()
        },
        methods: {
            index () {
                this.loading = true
                axios
                    .get('/api/users?search=' + this.search_user)
                    .then((response) => {
                        this.loading = false
                        this.users = response.data.data
                    })
            },
            search () {
                clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.index()
                }, 1000)
            },
            resume (user) {
                this.eventHub.$emit('user-workload-to-company-modal', user)
            },
            tasksUser (user) {
                this.eventHub.$emit('tasks-made-by-user-modal', user)
            },
            grandResume () {
                this.eventHub.$emit('workload-to-companies-modal')
            },
            grandTasks () {
                this.eventHub.$emit('tasks-made-all-modal')
            }
        }
    }
</script>

<style scoped lang="sass">
    .tasks-table
        td
            button
                margin-left: 5px

</style>
